import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { fetchContent } from '../services/contentService';
import Spinner from "react-loading-indicators/OrbitProgress";

// TODO: might be nice to add size controls to the content, so user's can adjust the size themselves
const ContentDisplay = ({ subTopicId }) => {
  const { t, i18n } = useTranslation();
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);


  // TODO: consider using DOMPurify to sanitize HTML content before rendering
  // TODO: memoize fetchContent to prevent identical service calls
  useEffect(() => {
    const fetchSubTopicContent = async () => {
      if (!subTopicId) {
        setContent(null);
        setLoading(false);
        setError(null);
        return;
      }

      setLoading(true);
      setError(null);

      try {
        // let getSubTopic = 'getSubtopic';
        

        // const query = `query ($id: ID!) {
        //   ${getSubTopic}(where: { id: $id }) {
        //     data {
        //       id
        //       title
        //       articleContent(format: "html")
        //     }
        //   }
        // }`;

        let listSubTopics = 'listSubtopics';


        const query = `query  {
        ${listSubTopics}${buildWhereClause(subTopicId)} {
            data {
              id
              title
              articleContent(format: "html")
            }
          }
        }`;

        const response = await fetchContent(query, { language: i18n.language, id: subTopicId });
        const subtopic = response[listSubTopics].data[0];
        if (!subtopic) {
          throw new Error('SubTopic not found');
        }
        setContent({
          title: subtopic.title,
          body: subtopic.articleContent,
        });
        setLoading(false);
      } catch (err) {
        console.error('Content fetch error:', err);
        setError(t('error'));
        setLoading(false);
      }
    };

    fetchSubTopicContent();
  }, [subTopicId, i18n.language, t]);

  if (loading) return (
    <div className="flex justify-center items-start mt-[85px] min-h-[120px]">
      <Spinner dense color="#8034c4" size="large" speedPlus="-1" text="Loading" textColor="" aria-busy="true" aria-live="polite" role="status" aria-label="Loading" />
    </div>
  );
  if (error) return <p className="text-red-600">{error}</p>;
  if (!content) return null;

  return (
    <div style={{ paddingBottom: '15px' }}>
      <article className="bg-white p-4 rounded-xl shadow prose w-full mx-auto max-w-3xl lg:max-w-4xl xl:max-w-5xl">
        <h2 className="text-xl font-semibold mb-2">{content.title}</h2>
        <div dangerouslySetInnerHTML={{ __html: content.body }} />
      </article>
    </div>
  );
};

function buildWhereClause(subTopicId) {
  if (!subTopicId) return '';
  return `(where: { OR: [{ id: "${subTopicId}#0001" }, { id: "${subTopicId}#0002" }, { id: "${subTopicId}#0003" }, { id: "${subTopicId}#0004" }, { id: "${subTopicId}#0005" }, { id: "${subTopicId}#0006" }, { id: "${subTopicId}#0007" }, { id: "${subTopicId}#0008" }, { id: "${subTopicId}#0009" }, { id: "${subTopicId}#00010" }] }) `;
}

export default ContentDisplay;